"use strict";
Object.defineProperty(exports, Symbol.toStringTag, { value: "Module" });
const React = require("react");
const RadioContext = React.createContext(null);
function useRadioProvider() {
  const context = React.useContext(RadioContext);
  if (!context) {
    throw new Error(
      "Radio must be used within a RadioGroup. Please wrap your Radio components in a RadioGroup."
    );
  }
  return context;
}
exports.RadioContext = RadioContext;
exports.useRadioProvider = useRadioProvider;
